var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdviseMan = function SvgAdviseMan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2399EE",
    d: "M8.758 60.286C8.758 47.978 18.736 38 31.044 38h18.429c12.308 0 22.285 9.978 22.285 22.286A3.714 3.714 0 0 1 68.044 64H12.473a3.714 3.714 0 0 1-3.715-3.714"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.758,
    cy: 16,
    r: 16,
    fill: "#4EADF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1081D3",
    d: "M55.76 64h12.434a3.714 3.714 0 0 0 3.714-3.714C71.908 47.978 61.931 38 49.623 38h-4.865z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4EADF1",
    fillRule: "evenodd",
    d: "M39.758 38h-8.714C18.736 38 8.758 47.978 8.758 60.286A3.714 3.714 0 0 0 12.473 64h27.285z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F1",
    d: "M29.05 37.83A2 2 0 0 1 30.87 35h18.637c1.49 0 2.457 1.572 1.785 2.902L41.5 57.285c-.756 1.497-2.908 1.454-3.605-.071z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#103C68",
    fillRule: "evenodd",
    d: "M36.758 34a3 3 0 1 0 0 6h.2l-2.733 13.666a4 4 0 0 0 1.362 3.858L39.758 61l4.172-3.476a4 4 0 0 0 1.362-3.858L42.558 40h.2a3 3 0 1 0 0-6z",
    clipRule: "evenodd"
  })));
};
export { SvgAdviseMan as ReactComponent };
export default "/images/advise-man.svg";